module.exports = __webpack_public_path__ + "static/media/ico_kotak_512.608d5243.png";